import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const fetchAllIntents = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/intents', METHOD_TYPES.GET, data, callback);
};

export const getIntentData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/intent', METHOD_TYPES.GET, data, callback);
};

export const addNewUtterance = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/utterance', METHOD_TYPES.POST, data, callback);
};

export const deleteUtterance = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/utterance', METHOD_TYPES.DELETE, data, callback);
};

export const updateUtterance = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/utterance', METHOD_TYPES.PUT, data, callback);
};

export const deleteIntent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/intent', METHOD_TYPES.DELETE, data, callback);
};

export const updateIntent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/intent', METHOD_TYPES.PUT, data, callback);
};

export const createIntent = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/intent', METHOD_TYPES.POST, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/intent_details/api.js